module.exports = __webpack_public_path__ + "src/submodules/base/assets/img/voicemod-loader.2c2853f6.gif";